import React, { Component } from 'react';
import Helmet from "react-helmet";
import Toto from '../../components/toto';

// @inject('lineStore')
// @observer
export default class TotoPage extends Component { 
	render() {
			return(
				<div className="toto-page">
					<Helmet>
						<title>ИРМ - Тото</title>
					</Helmet>
					<div className="toto-page__body">
						<Toto />
					</div>
				</div> 
			)
	}
}
 


// WEBPACK FOOTER //
// ./src/routes/toto/index.js